export default {
  lookingForWork: false,
  currentWorkplace: {
    name: 'Living Security',
    title: 'Principal UX/UI Engineer',
    link: 'https://www.livingsecurity.com/'
  }
}